import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { TextValide } from "@goodgamestudios/core";

import { Keyboard } from "@goodgamestudios/createjs-utilities";
import { KeyboardEvent } from "@goodgamestudios/createjs-utilities";
import { TextField } from "@goodgamestudios/createjs-utilities";

import { SFConstants } from "../../../constants/SFConstants";
import { Balancing } from "../../../constants/shared/Balancing";
import { Poker2UserEvent } from "../../../event/Poker2UserEvent";
import { Poker2Model } from "../../../model/Poker2Model";
import { PokerTextHelper } from "../../helper/PokerTextHelper";
import { Poker2Dialog } from "../Poker2Dialog";
import { Poker2MailVerificationGiftDialogProperties } from "./Poker2MailVerificationGiftDialogProperties";

import Container = createjs.Container;
import MouseEvent = createjs.MouseEvent;

export class Poker2MailVerificationDialog extends Poker2Dialog {
    public static NAME: string = "Poker2MailVerificationDialog";

    private isWaitingForServerMessage: boolean = false;

    constructor(disp: Container) {
        CONSTRUCTOR_HACK;
        super(disp);
    }

    protected init(): void {
        this.controller.addEventListener("emailverificationFaild", this.bindFunction(this.onRegisterComplete));
        this.controller.addEventListener("emailverificationCompleted", this.bindFunction(this.onRegisterComplete));
        super.init();
    }

    public destroy(): void {
        this.controller.removeEventListener("emailverificationFaild", this.bindFunction(this.onRegisterComplete));
        this.controller.removeEventListener("emailverificationCompleted", this.bindFunction(this.onRegisterComplete));
        super.destroy();
    }

    protected applyProperties(): void {
        this.isWaitingForServerMessage = false;

        this.registerDial.txt_email.text = (Poker2Model.userData.email) ? Poker2Model.userData.email : "";
        this.registerDial.btn_login.label = Poker2Model.languageData.getTextById("dialog_pesentreminder_send");

        this.registerDial.txt_chips.text = "x" + PokerTextHelper.getShortGroupNumberString(5000);
        TextFieldHelper.changeTextFromatSizeByTextWidth(24, this.registerDial.txt_title, Poker2Model.languageData.getTextById("dialog_pesentreminder_title"));
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.registerDial.txt_copy, Poker2Model.languageData.getTextById("dialog_pesentreminder_text1", [5000, 5]), 5);
        TextFieldHelper.changeTextFromatSizeByTextWidth(12, this.registerDial.txt_copy2, Poker2Model.languageData.getTextById("dialog_pesentreminder_text2"), 2);
    }

    protected onClick(event: MouseEvent): void {
        super.onClick(event);
        switch (event.target) {
            case this.registerDial.btn_login:
                this.onLogin();
                break;
            case this.registerDial.btn_close:
                this.hide();
                break;
            case this.registerDial.txt_email:
                (event.target as TextField).setSelection(0, (event.target as TextField).text.length);
                break;
        }
    }

    protected onKeyUp(event: KeyboardEvent): void {
        if (event.target == this.registerDial.txt_email && event.keyCode == Keyboard.ENTER)
            this.onLogin();
    }

    private onLogin(): void {
        if (this.isWaitingForServerMessage) return;
        if (this.registerDial.txt_email.text.length == 0 || !TextValide.isSmartFoxValide(this.registerDial.txt_email.text)) {
            this.layoutManager.showDialog(Poker2StandardOkDialog.NAME, new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("error_register_title"),
                Poker2Model.languageData.getTextById("generic_register_email_copy")));
            return;
        }

        this.isWaitingForServerMessage = true;
        this.controller.sendServerMessageAndWait("emv",
            [JSON.stringify({ email: this.registerDial.txt_email.text.trim() })], "emv");
    }

    private onRegisterComplete(e: Poker2UserEvent): void {
        this.isWaitingForServerMessage = false;
        if (e.params == null || e.params.length == 0) {
            this.layoutManager.showDialog("Poker2MailVerificationGiftDialog", new Poker2MailVerificationGiftDialogProperties(
                Poker2Model.languageData.getTextById("dialog_pesentreminder_title"), Poker2Model.languageData.getTextById("dialog_shippingconfirmation_send"), "sendMail"));
            this.hide();
        }
    }

    protected get registerDial(): Library.PokerPopUps.Poker2MailVerification {
        return this.disp as Library.PokerPopUps.Poker2MailVerification;
    }
}
import { Poker2StandardOkDialog } from "../Poker2StandardOkDialog";
import { Poker2MailVerificationGiftDialog } from "./Poker2MailVerificationGiftDialog";
